<div class="service-unavailable-banner" role="alert">
  <p class="service-unavailable-banner__title">
    {{ 'BATCH_MAILING.BATCHES_TAB.SERVICE_UNAVAILABLE.TITLE' | translate }}
  </p>
  <p class="service-unavailable-banner__text">
    {{
      'BATCH_MAILING.BATCHES_TAB.SERVICE_UNAVAILABLE.DESCRIPTION' | translate
    }}
  </p>
</div>
